"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var custom_event_1 = tslib_1.__importDefault(require("custom-event"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var ColoredItem_1 = tslib_1.__importDefault(require("./ColoredItem"));
var colors_1 = require("../../../../utils/colors");
var VISIBLE_ITEMS_COUNT = 5;
var SEARCHFIELD_VISIBILITY_THRESHOLD = 7;
var DROPDOWN_BODY_WIDTH = 218;
var ColoredItemsList = /** @class */ (function (_super) {
    tslib_1.__extends(ColoredItemsList, _super);
    function ColoredItemsList(props) {
        var _this = _super.call(this, props) || this;
        _this.onScroll = function () {
            if (_this.listRef && _this.listRef.current) {
                var node = _this.listRef.current;
                node.dispatchEvent(new custom_event_1.default("goodstrap.scrolled", { bubbles: true }));
            }
        };
        _this.onSearch = function (searchString) {
            _this.setState({ searchString: searchString });
            _this.closeOpenDropdownOnSearch();
        };
        _this.isSearchFieldVisible = function () {
            return _this.props.inputItems.length > SEARCHFIELD_VISIBILITY_THRESHOLD && !_this.props.isLoading;
        };
        _this.onSelect = function (selectedColorItem, color) {
            _this.props.onSelect(selectedColorItem, color);
        };
        _this.state = {
            searchString: "",
        };
        _this.listRef = react_1.default.createRef();
        return _this;
    }
    ColoredItemsList.prototype.render = function () {
        var _this = this;
        var searchString = this.isSearchFieldVisible() ? this.state.searchString : "";
        var items = colors_1.getSearchedItems(this.props.inputItems, searchString);
        return (react_1.default.createElement("div", { ref: this.listRef },
            react_1.default.createElement(sdk_ui_kit_1.DropdownList, { width: DROPDOWN_BODY_WIDTH, showSearch: this.isSearchFieldVisible(), searchString: searchString, onSearch: this.onSearch, onScrollStart: this.onScroll, items: items, className: "gd-colored-items-list", maxVisibleItemsCount: VISIBLE_ITEMS_COUNT, isLoading: this.props.isLoading, renderItem: function (_a) {
                    var item = _a.item;
                    return (react_1.default.createElement(ColoredItem_1.default, { colorPalette: _this.props.colorPalette, onSelect: _this.onSelect, showCustomPicker: _this.props.showCustomPicker, disabled: _this.props.disabled, item: item }));
                } })));
    };
    ColoredItemsList.prototype.closeOpenDropdownOnSearch = function () {
        // we have to close all dropdown ONE-3526
        // (IE has bug onClick on ClearIcon in Input doesn't fire click event and dropdown will not close)
        // so we can close it by onScroll event
        this.onScroll();
    };
    ColoredItemsList.defaultProps = {
        disabled: false,
        isLoading: false,
    };
    return ColoredItemsList;
}(react_1.default.PureComponent));
exports.default = react_intl_1.injectIntl(ColoredItemsList);
//# sourceMappingURL=ColoredItemsList.js.map